export default "__VITE_ASSET__WaCx_PRC__"